<template>
  <div id="layout">
    <nav class="navbar sticky-top flex-md-nowrap p-0 navbar-expand-md">
      <a
        class="navbar-brand col-sm-3 col-md-2 mr-0"
        href="#"
      ><img
        :src="logoExt"
        alt="logo extended"
      ></a>

      <ul class="navbar-nav d-md-none ml-2">
        <li class="nav-item toggle-side">
          <button
            class="btn"
            data-toggle="modal"
            data-target="#toggle-menu"
          >
            <i class="fa fa-bars" />
          </button>
        </li>
      </ul>
      <ul class="navbar-nav px-3 inline ml-auto">
        <li class="nav-item">
          <img
            :src="avatarOrPlaceholder"
            class="img-fluid img-thumbnail avatar"
            alt="avatar"
          >
        </li>
        <li class="nav-item dropdown">
          <a
            id="navbarDropdown"
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ currentUser.name }}
          </a>
          <div
            class="dropdown-menu"
            aria-labelledby="navbarDropdown"
          >
            <router-link
              class="dropdown-item"
              :to="theLink"
            >
              Edit Profile
            </router-link>
            <button
              type="button"
              class="dropdown-item"
              @click="handleLogout"
            >
              Sign Out
            </button>
          </div>
        </li>
      </ul>
    </nav>
    <div
      id="toggle-menu"
      class="modal fade d-md-none"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog rounded-0"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <span
              id="exampleModalLabel"
              class="modal-title"
            ><span
              class="navbar-brand col-sm-3 col-md-2 mr-0"
              href="#"
            ><img
              :src="logoExt"
              alt="logo extended"
            ></span></span>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body list-unstyled">
            <slot name="menuItems" />
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <nav class="col-md-2 d-none d-md-block sidebar">
          <div class="sidebar-sticky">
            <ul
              class="nav flex-column"
              style="margin-top: 25%;"
            >
              <slot name="menuItems" />
            </ul>
          </div>
        </nav>
        <main
          role="main"
          class="col-md-10 ml-sm-auto col-lg-10 pt-3 px-4 bg-general"
        >
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ currentPage }}
            </h1>
            <slot name="side info" />
          </div>
          <div class="col-md-p">
            <slot name="messages" />
          </div>
          <div>
            <slot name="content" />
          </div>
        </main>
      </div>
    </div>
    <footer><small><b>©Copyright EPD 2020.</b> All rights reserved to Energy Private Developers.</small></footer>
  </div>
</template>

<script>
import logoExt from "@/assets/images/logo-extended.png";
import avatarPlaceholder from "@/assets/images/avatar.svg";
import { mapGetters } from "vuex";
export default {
  name: "Layout",
  // props: ["avatar", "username", "linkToEdit", "currentPage"],
  props: {
    avatar: {
      type: Image,
      default: ''
    },
    username: {type:String, default: ''},
    linkToEdit: {type:String, default: ''},
    currentPage: {type:String, default: ''}
  },
  data() {
    return {
      logoExt,
      avatarPlaceholder,
      theAvatar: this.avatar,
      theLink: this.linkToEdit,
    };
  },
  computed: {
    ...mapGetters({ currentUser: "auth/currentUser" }),
    avatarOrPlaceholder() {
      if (!this.theAvatar) {
        this.theAvatar = this.avatarPlaceholder;
      }
      return this.theAvatar;
    },
  },
  methods: {
    navigateTo: function () {
      return this.$router.push(this.linkToEdit);
    },
    handleLogout: function () {
      this.$store.dispatch("auth/logout", () => {
        this.$router.replace("/login");
      });
    },
  },
};
</script>

<style scoped>
/*
 * Sidebar
 */
.modal {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  overflow: hidden;
}

.modal-dialog {
  position: fixed;
  margin: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border-radius: 0;
}

.modal-content {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  border: 2px solid #fff;
  border-radius: 0;
  box-shadow: none;
}

.modal-body a {
  text-decoration: none;
  color: #333;
  font-size: 14pt;
}

.toggle-side {
  align-self: flex-start;
}

.toggle-side button {
  color: #fff;
}

nav {
  background: #8bc34a;
}

main {
  height: 100vh;
  overflow-y: scroll;
}

a.dropdown-toggle {
  color: #fff;
}

a.dropdown-toggle:hover {
  color: #eee;
}

.inline {
  display: flex;
  flex-direction: row;
  flex-grow: 1px;
}

.avatar {
  height: 32px;
  width: 32px;
  background-color: #c5c5c5;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  margin-top: 2px;
}

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  /* Behind the navbar */
  padding: 0;
}

.sidebar-sticky {
  position: -webkit-sticky;
  background: #fff;
  position: sticky;
  top: 48px;
  /* Height of navbar */
  height: 100vh;
  padding-top: 2rem;
  overflow: hidden;
  /* Scrollable contents if viewport is shorter than content. */
}

.sidebar .nav-link {
  font-weight: 500;
  color: #333;
}

.sidebar .nav-link a:hover {
  color: #8bc34a;
  background: #faffe1;
}

/*
 * Navbar
 */

.navbar-brand {
  background-color: #fff;
}

.navbar-brand img {
  height: 60%;
  width: 60%;
}

.navbar .form-control {
  border-width: 0;
  border-radius: 0;
}

/*
 * Utilities
 */

.border-top {
  border-top: 1px solid #e5e5e5;
}

.border-bottom {
  border-bottom: 1px solid #e5e5e5;
}
footer {
  width: 100%;
  height: 50px;
  background: #e0e0e0;
  padding: 15px  0 0 15px;
  font-size: 9pt;
  position: relative;
  bottom: 0;
}

@media only screen and (min-width: 768px) {
  main {
  height: 95vh;
  overflow-y: scroll;
}
footer {
  width: 100%;
  height: 50px;
  background: #e0e0e0;
  padding: 15px  0 0 18%;
  position: fixed;
  bottom: 0;
}
}
</style>
